<script setup lang="ts">
import type { WorkshopName } from "@/utils/enums";

const props = defineProps<{ level: LevelName }>();
const workshop = defineModel<WorkshopName>("workshop");

const items = computed<{ value: WorkshopName; label: string }[]>(() => {
  switch (props.level) {
    case "childhood":
      return Object.entries(childhookWorkshopLabels).map(([value, label]) => ({ value: value as WorkshopName, label }));
    case "elementary":
    case "secondary":
    case "fga":
      return Object.entries(generalWorkshopLabels).map(([value, label]) => ({ value: value as WorkshopName, label }));
    case "collegial":
    case "fp":
      return Object.entries(professionalWorkshopLabels).map(([value, label]) => ({ value: value as WorkshopName, label }));
    default :
      return [];
  }
});

const { isMobile } = useResponsive();
const orientation = computed(() => isMobile.value ? "vertical" : "horizontal");

function onClear() {
  workshop.value = undefined;
}
</script>

<template>
  <div class="flex items-center gap-3">
    <URadioGroup v-model="workshop" :items="items" :orientation="orientation" variant="card" />
    <UButton v-if="workshop" icon="i-lucide-x" color="neutral" variant="ghost" @click="onClear" />
  </div>
</template>
